import React from 'react';
import { Field, useFormikContext } from 'formik';

import Box from '@material-ui/core/Box';

import { FormikInput } from '../../_core/Formik/formik-input.component';
import { FormikCheckbox } from '../../_core/Formik/formik-checkbox.component';
import { FieldCaption } from '../../_core/_ui/field-caption.component';
import { SettingsSection } from '../../_core/_ui/settings-section.component';
import { IntlMsg } from '../../_core/IntlMsg/intl-msg.component';
import { CALIBRATION_SETTING_GROUPS } from './calibration-settings-field.constants';
import { messages } from './calibration-settings-field.messages';

interface ICalibrationSettingsFieldProps {
  fid?: string;
}

interface ICalibrationFormValues {
  hasCalibrationVideos?: boolean;
}

export const CalibrationSettingsField: React.FC<ICalibrationSettingsFieldProps> = ({ fid = 'ucf' }) => {
  const { values } = useFormikContext<ICalibrationFormValues>();
  const captionId = `${fid}-hasCalibrationVideos-caption`;

  return (
    <Box>
      <Field
        fid={fid}
        name="hasCalibrationVideos"
        component={FormikCheckbox}
        label={messages.lblEnableCalibrationVideos}
        // MUI routes `inputProps` to the underlying <input>; a bare aria-describedby
        // would land on the wrapping button instead, where AT never reads it.
        inputProps={{ 'aria-describedby': captionId }}
      />
      <FieldCaption id={captionId} underCheckbox>
        <IntlMsg {...messages.calibrationEnabledHelp} />
      </FieldCaption>
      {values.hasCalibrationVideos && (
        <Box ml={4}>
          {CALIBRATION_SETTING_GROUPS.map(group => (
            <SettingsSection
              key={group.key}
              nested
              title={<IntlMsg {...group.title} />}
              description={<IntlMsg {...group.description} />}
            >
              {group.fields.map(({ name, label, hint }) => (
                <Field
                  key={name}
                  fid={fid}
                  name={name}
                  component={FormikInput}
                  type="number"
                  min={1}
                  step={1}
                  margin="dense"
                  label={label}
                  hint={<IntlMsg {...hint} />}
                />
              ))}
            </SettingsSection>
          ))}
        </Box>
      )}
    </Box>
  );
};
